import React, { Component } from "react";
// import ReactExport from "react-data-export";
import ExportPDF from "./cheque_export_pdf.js";
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;

const config = require('../../config.js');
const backend = config.backend;


const tableStyles = {
  rows: {
    style: {
      minHeight: '35px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '16px', // override the cell padding for head cells
      paddingRight: '8px',
      fontWeight: 'bold',
      fontSize: '14px'
    },
  },
  cells: {
    style: {
      paddingLeft: '16px', // override the cell padding for data cells
      paddingRight: '8px',
      fontSize: '14px'
    },
  },
  loading: {
    style: {
      display: "flex",
      // textAlign: 'center'
    }
  }
};

const columns = [
  {
    name: 'DesigID',
    selector: 'DesigID',
    cell: row => {
      if (isNaN(row.DesigID) && row.DesigID !== undefined)
        return (<div style={{ fontWeight: 'bold', fontSize: '15px' }}>{row.DesigID}</div>)
      else return (<div>{row.DesigID}</div>)
    }
  },
  {
    name: 'RcCode',
    selector: 'RcCode',
    sortable: true,
  },
  {
    name: 'Designation Name',
    selector: 'DesigName',
    grow: 2,
    cell: row => {
      if (row.DesigName === 'Total')
        return (<div style={{ fontWeight: 'bold' }}>{row.DesigName}</div>)
      else return (<div>{row.DesigName}</div>)
    }
  },
  {
    name: 'Cheque Charges',
    selector: 'Cheque',
    sortable: true,
    right: true,
    cell: row => {
      if (row.Cheque) return (<div>${numberWithCommas_display(row.Cheque)}</div>)
    }
  },
];


const total_columns = [
  { selector: 'col1', hidden: true },
  { selector: 'col2', hidden: true },
  {
    selector: 'colName', hidden: true, right: true,
    cell: row => {
      return (<div style={{ fontWeight: 'bold' }}>{row.colName}</div>)
    }
  },
  {
    selector: 'total', hidden: true, right: true,
    cell: row => {
      return (<div style={{ fontWeight: 'bold' }}>${row.total}</div>)
    }
  },
];


class Cheque_Report extends Component {

  constructor(props) {
    super(props);

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      checked: false,
      errors: {},
      loading: 'true',
      isButtonDisabled: false,
      redirectLogout: false
    }
  }

  _isMounted = false;


  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleStartDateChange(date) {

    date = moment(date).format('YYYY-MM-DD');

    this.setState({
      startDate: date
    });

  }

  handleEndDateChange(date) {

    date = moment(date).format('YYYY-MM-DD');

    this.setState({
      endDate: date
    });

  }

  inputValid = () => {
    let { startDate } = this.state;
    let { endDate } = this.state;
    let today = new Date()
    let errors = {};

    if (startDate > endDate || startDate > today) {

      errors['date'] = 'Please choose correct dates!'; this.setState({ errors: errors });
      return false;

    }
    else {
      errors = {};
      this.setState({ errors: errors });
      return true;

    }

  }


  getChequeCharges(startDate, endDate) {

    var that = this;

    endDate = moment(endDate).format('YYYY-MM-DD');
    startDate = moment(startDate).format('YYYY-MM-DD');

    return new Promise(function (resolve, reject) {

      var url = `api/donation/chequereport/?start=` + startDate + `&end=` + endDate;
      console.log(url)

      fetch(backend + url, {
        method: 'GET',
        credentials: "include"
      })
        .then(response => response.json())
        .then(response => {
          console.log(response);
          if (response.redirect) {
            that.setState({ redirectLogout: true })
            window.location.reload(false);
          }
          else if (response.status === 500) {
            reject(response.message)
          }
          else {
            resolve(response)
          }
        })
        .catch((err) => {
          console.log('getChequeCharges error', err);
          reject(err)
        })

    })
  }


  getReport = _ => {
    let { startDate } = this.state;
    let { endDate } = this.state;

    this.setState({ multiData: {} });

    if (this.inputValid()) {

      this.setState({ checked: true })
      this.getChequeCharges(startDate, endDate)
        .then((result) => {
          console.log("resultssss", result);
          this.setState({ multiData: result });
        })
        .catch((error) => {
          console.log('error', error)
          this.setState({ multiData: 'error' });
          NotificationManager.error(error.toString());
        });

    }

  }



  mergeGroupNameToData(data, columns) {

    var table_data = []
    var row_length = columns.length

    for (var i = 0; i < data.length; i++) {

      if (data[i].desigs) { // If this group has gift

        var groupname_row = {}
        var total_row = {}

        groupname_row[columns[0].selector] = data[i].group // assign groupname to first cell of new row


        for (var k = 1; k < row_length; k++) {
          groupname_row[columns[k].selector] = '';

          //console.log(data[i])

          if (columns[k].selector === 'DesigName') {
            total_row[columns[k].selector] = 'Total';
          }
          if (columns[k].selector === 'CreditCard') {
            total_row[columns[k].selector] = data[i].credit_total;
          }
          if (columns[k].selector === 'Cheque') {
            total_row[columns[k].selector] = data[i].cheque_total;
          }
        }

        table_data.push(groupname_row);
        table_data = table_data.concat(data[i].desigs);
        table_data = table_data.concat(total_row);


      }

    }

    return table_data

  }


  renderReport() {
    const { multiData } = this.state;

    let checked = this.state.checked;

    if (checked) {

      if (multiData === 'error') {
        return <h4 className='title'> Cannot get data from database... </h4>
      }

      else if (multiData && Object.keys(multiData).length) {

        console.log('multiData is updated', multiData);

        multiData['columns'] = columns;
        const title = multiData.title;
        console.log("multidata", multiData);
        const total_data = multiData.total_data;
        console.log('original table data', multiData.data)
        const table_data = this.mergeGroupNameToData(multiData.data, columns);
        console.log('table data', table_data)


        return (
          <div>


            <ExportPDF data={multiData} />

            <DataTable
              highlightOnHover
              title={title}
              columns={columns}
              data={table_data}
              customStyles={tableStyles}
            />

            {(table_data.length > 0) ?

              <DataTable
                highlightOnHover
                columns={total_columns}
                data={total_data}
                customStyles={tableStyles}
                noTableHead
                noHeader
              /> : null

            }

          </div>);

      }

      else {
        // console.log('multiData is empty');
        return (
          <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
            <h4 className='title'>Loading... This may take a while... </h4>
            <CircularProgress/>
          </div>
        )
      }

    }

  }


  render() {
    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    let report_table = this.renderReport();

    return (<div className="sorted-donation-report">
      <h3 className="title">Cheque Charges Report</h3>
      <div className="form-set row">
        <form className="form-horizontal">
          <div className="form-sets col-sm-12">
            <fieldset>
              <div className="fieldset">
                <div className='input-dates col-sm-10'>

                  <div className="col-sm-4 input-startdate">
                    <label className="col-lg-4 control-lebel"> START DATE</label>
                    <div className='datepicker'>
                      <DatePicker
                        selected={(this.state.startDate === '') ? new Date() : new Date(this.state.startDate)}
                        onChange={this.handleStartDateChange}
                        dateFormat='dd-MM-yyyy'
                      />
                    </div>
                  </div>

                  <div className="col-sm-4 input-enddate">
                    <div className='float-right'>
                      <label className="col-lg-4 control-lebel"> END DATE</label>
                      <div className='datepicker datepicker-right'>
                        <DatePicker
                          selected={(this.state.endDate === '') ? new Date() : new Date(this.state.endDate)}
                          onChange={this.handleEndDateChange}
                          dateFormat='dd-MM-yyyy'
                        />
                      </div>
                      <span className="error">{this.state.errors["date"]}</span>
                    </div>
                  </div>

                </div>

                <div className="col-sm-2 check-button">
                  <button type="button" className="btn btn-primary submit" disabled={this.state.isButtonDisabled} onClick={this.getReport}>CHECK</button>
                </div>

              </div>
            </fieldset>
          </div>
        </form>
      </div>

      <div className="report-table" id="reserve-table">
        {report_table}
      </div>
      <NotificationContainer />

    </div>);

  }

}


export default Cheque_Report;
